import React from "react";
import { Row, Col } from "react-bootstrap";
import TitleCard from "../Shared/TitleCard/TitleCard";
import styles from "./AboutContent.module.css";
import img1 from "../../assets/About/1.png";
import img2 from "../../assets/About/2.png";
import img3 from "../../assets/About/3.png";
import img4 from "../../assets/About/4.png";
import img5 from "../../assets/About/5.png";
import img6 from "../../assets/About/6.png";
import img7 from "../../assets/About/7.png";
import img8 from "../../assets/About/8.png";
import img9 from "../../assets/About/9.png";
import img10 from "../../assets/About/10.png";
import img11 from "../../assets/About/11.png";
import img12 from "../../assets/About/12.png";
import img13 from "../../assets/About/13.png";
import img14 from "../../assets/About/14.png";

const AboutContent = () => {
  return (
    <div>
      <TitleCard title="What do we do?" className={"pt-4"} />
      <span className="d-block ">
        Technowren is a company which provides prototyping, manufacturing,
        designing and fabrication of a mechanical/ electronics/ embedded
        system.Currently our services are:
      </span>
      <ul className="pt-3 pb-5">
        <li>3D printing (FDM, SLA)</li>
        <li>Laser cutting (Plastic, paper, organic material, plastic sheet)</li>
        <li>PCB manufacturing</li>
        <li>Silicon Molding (low quantity mass production of plastic)</li>
        <li>Product or prototype development</li>
      </ul>
      <TitleCard title="Who are our Clients?" className={"pt-4"} />

      <span className="d-block pb-5">
        Our clients are startups/ companies/ industries who need fabrication/
        prototyping of their products, need small quantity mass production or
        need any kind of reverse engineering.
        <br />
        <br />
        Individuals like students, innovators or even a team of expertees can
        also get similar support from TechnoWren. Our business model is based on
        providing good quality and expert solutions to both individuals or
        companies.
      </span>
      {/* <TitleCard title="What Machineries do we have?" className={"pt-4"} />
      <span className="d-block pb-5">
        Currently we have manichinaries to fabricate plastic parts mostly. They
        are listed below:
      </span>
      <span className="d-block h4 fw-bolder">FDM 3D printer: Quantity 6</span>
      <ul className="pt-3 pb-3">
        <li>Filament Based’</li>
        <li>Easy to print</li>
        <li>Cheaper</li>
        <li>Faster</li>
        <li>Best for prototypes</li>
      </ul>
      <span className="d-block h5 fw-bolder">Sample Pictures</span>
      <Row>
        <Col md={4} className="p-3">
          <div className={styles.prod}>
            <img src={img1} alt="" className={styles.prod_img} />
          </div>
        </Col>
        <Col md={4} className="p-3">
          <div className={styles.prod}>
            <img src={img2} alt="" className={"w-100"} />
          </div>
        </Col>
        <Col md={4} className="p-3">
          <div className={styles.prod}>
            <img src={img3} alt="" className={styles.prod_img} />
          </div>
        </Col>
      </Row>
      <span className="d-block h5 fw-bolder pt-4">
        SLA 3D Printer :Quantity 5
      </span>
      <ul className="pt-3 pb-5">
        <li>Resin based</li>
        <li>High resolution</li>
        <li>Great for organic shapes</li>
        <li>Best for final product like outlook</li>
      </ul>

      <span className="d-block h5 fw-bolder">Sample Pictures</span>
      <Row>
        <Col md={4} className="p-3">
          <div className={styles.prod}>
            <img src={img4} alt="" className={"w-100"} />
          </div>
        </Col>
        <Col md={4} className="p-3">
          <div className={styles.prod}>
            <img src={img5} alt="" className={"w-100"} />
          </div>
        </Col>
        <Col md={4} className="p-3">
          <div className={styles.prod}>
            <img src={img6} alt="" className={"w-100"} />
          </div>
        </Col>
      </Row>
      <span className="d-block h5 fw-bolder pt-4">
        CO2 Laser cutter industrial 1300mm x 900mm
      </span>
      <span className="d-block h5 fw-bolder">Sample Pictures</span>
      <Row>
        <Col md={4} className="p-3">
          <div className={styles.prod}>
            <img src={img7} alt="" className={"w-100"} />
          </div>
        </Col>
        <Col md={4} className="p-3">
          <div className={styles.prod}>
            <img src={img8} alt="" className={"w-100"} />
          </div>
        </Col>
        <Col md={4} className="p-3">
          <div className={styles.prod}>
            <img src={img9} alt="" className={"w-100"} />
          </div>
        </Col>
      </Row>
      <span className="d-block h5 fw-bolder pt-4">Other Machineries</span>
      <ul>
        <li className="fw-bold">PCB manufacturing setup</li>
        <li className="fw-bold">Silicon Molding setup</li>
        <li className="fw-bold">Engineering team for product development</li>
      </ul> */}
      <TitleCard title="What Projects have we done?" className={"pt-5"} />
      <span className="d-block h5 fw-bolder pt-4">
        1. Ultra supercritical Steam Power Plant turbine scale model:
      </span>
      <span className="d-block">
        A 1/10 scale model of an ultra supercritical power plant’s scale model.
        Fully 3D printed and laser cut.{" "}
      </span>
      <span className="d-block h5 fw-bolder pt-3">Sample Pictures</span>
      <Row>
        <Col md={4} className="p-3">
          <div className={styles.prod}>
            <img src={img10} alt="" className={"w-100"} />
          </div>
        </Col>
        <Col md={4} className="p-3">
          <div className={styles.prod}>
            <img src={img11} alt="" className={"w-100"} />
          </div>
        </Col>
        <Col md={4} className="p-3">
          <div className={styles.prod}>
            <img src={img12} alt="" className={"w-100"} />
          </div>
        </Col>
      </Row>

      <span className="d-block h5 fw-bolder pt-4">2. Kitty</span>
      <span className="d-block">
        Kitty is a STEM toy that can be programmed in bangla. It was designed
        and manufactured by Technowren.
      </span>
      <span className="d-block h5 fw-bolder pt-3">Sample Pictures</span>
      <Row className="pb-5">
        <Col md={4} className="p-3">
          <div className={styles.prod}>
            <img src={img13} alt="" className={"w-100"} />
          </div>
        </Col>
        <Col md={4} className="p-3">
          <div className={styles.prod}>
            <img src={img14} alt="" className={"w-100"} />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default AboutContent;
